import { useLocation } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import qs from 'query-string'
import { useSubdomainInfo } from 'shared/Site/api'
import { SiteType } from 'shared/Site/siteType'
import { getVoucherOrders } from 'utils/api/OrderHistory/getVoucherOrders'
import orderHistoryQueryKeys from 'utils/api/OrderHistory/orderHistoryQueryKeys'
import { useCurrentUser } from 'utils/hooks/useCurrentUser'

export const useVoucherOrders = () => {
  const { search } = useLocation()
  const { data } = useSubdomainInfo()
  const user = useCurrentUser()

  const params = qs.parse(search.replace('?', ''))
  const limit = (params?.limit || '3').toString()

  return useQuery({
    enabled: data?.data?.type !== SiteType.project && !!user,
    queryKey: orderHistoryQueryKeys.voucherOrdersList(limit),
    queryFn: () => getVoucherOrders(limit),
  })
}
